const INLINE_SCRIPT_ID = "afrimed-paystack-inline-js";
const INLINE_SCRIPT_SRC = "https://js.paystack.co/v2/inline.js";

function loadInlineJs() {
  if (typeof window === "undefined") return Promise.reject(new Error("Secure payment is only available in a browser."));
  if (window.PaystackPop) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const existing = document.getElementById(INLINE_SCRIPT_ID);
    if (existing) {
      existing.addEventListener("load", resolve, { once: true });
      existing.addEventListener("error", () => reject(new Error("Secure payment could not be loaded.")), { once: true });
      return;
    }
    const script = document.createElement("script");
    script.id = INLINE_SCRIPT_ID;
    script.src = INLINE_SCRIPT_SRC;
    script.async = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error("Secure payment could not be loaded."));
    document.head.appendChild(script);
  });
}

// Server initialization returns a short-lived access code. No card data or
// provider secret is handled by AfriMed™ in this browser handoff.
export async function openPaystackInlineCheckout(accessCode) {
  const code = String(accessCode || "").trim();
  if (!code) throw new Error("Secure payment was not prepared.");
  await loadInlineJs();
  if (typeof window.PaystackPop !== "function") throw new Error("Secure payment could not be loaded.");
  new window.PaystackPop().resumeTransaction(code);
}
